"use client";
import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import Tarifs from './inc/tarifs';
import Globe from "./components/magicui/globe.tsx";
import WordPullUp from "./components/magicui/word-pull-up.tsx";
import {AnimatedBeam} from "./components/magicui/animated-beam.tsx";


import { Link } from "react-router-dom";
import ErrorSvg from "./imgs/icons/error.svg";

import IconChat from "./imgs/icons/chat.svg";
import IconFast from "./imgs/icons/fast.svg";
import IconSecure from "./imgs/icons/secure.svg";
import IconFirewall from "./imgs/icons/firewall.svg";
import IconCard from "./imgs/icons/card.svg";
import IconSupport from "./imgs/icons/support.svg";
import IconRef from "./imgs/icons/reflink.svg";
import IconNews from "./imgs/icons/news.svg";
import IconInfinity from "./imgs/icons/infinity.svg";

import IconFlagRu from "./imgs/icons/flag_ru.png";
import IconUser from "./imgs/icons/user_emoji.png";
import IconFlagDE from "./imgs/icons/flag_de.png";

import IconSocVK from "./imgs/icons/vk-1-logo-svgrepo-com.svg";
import IconSocIG from "./imgs/icons/instagram-1-svgrepo-com.svg";

import React, { useEffect, useRef } from "react";

import { motion } from "framer-motion";
import LoadingSpinner from './inc/Loading';
import { Fragment, useState } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'


import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import Logo from './imgs/logo.svg'
import TelegramLoginButton from 'react-telegram-login';

import { Navigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk'


const BlurDefaultVariants = {
  hidden: { filter: "blur(10px)", opacity: 0 },
  visible: { filter: "blur(0px)", opacity: 1 },
};


var navigation = [
  { name: 'Преимущества', href: '#feautures' },
  { name: 'Цены', href: '#pricing' },
  { name: 'Поддержка', href: '#' },
  { name: 'Telegram бот', href: '#' },
]


function getRefHashValue() {
  var hash = window.location.hash; // Получаем хэш страницы
  if (hash.startsWith("#r_")) { // Проверяем, начинается ли хэш с "#r_"
      return hash.slice(3); // Если да, возвращаем значение после "#r_"
  } else {
      return null; // Если нет, возвращаем null
  }
}
function getPcidHashValue() {
  var hash = window.location.hash; // Получаем хэш страницы
  if (hash.startsWith("#p_")) { // Проверяем, начинается ли хэш с "#r_"
      return hash.slice(3); // Если да, возвращаем значение после "#r_"
  } else {
      return null; // Если нет, возвращаем null
  }
}


function OpenLink(link){
  try{
  WebApp.openLink(link);
  }catch(e){ 
    window.open(link, '_blank');
  }
}


function App(args) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const containerRef = useRef(null);
  const div1Ref = useRef(null);
  const div2Ref = useRef(null);
  const div3Ref = useRef(null);
  const div4Ref = useRef(null);
  const div5Ref = useRef(null);
  const [AuthModalOpen, setAuthModalOpen] = useState(false)
  const [AuthModalLoading, setAuthModalLoading] = useState(false)
  const [LoginError, setLoginError] = useState(false)
  const [Redirect, setRedirect] = useState('')
  const [Loading, setLoading] = useState(true)
  const [User, setUser] = useState({})
  const [Settings, setSettings] = useState({landing_navigation:navigation})

  useEffect( () => {

    if(getRefHashValue()){
      localStorage.setItem('ref',getRefHashValue());
    }
    async function get_user(){
    //  alert(1);
/*
      if(WebApp.initData){
        try{
        
        const response_auth = await axios.post(args.ApiUrl+"auth-tg?web_app=1",{initData:WebApp.initData});
        
        if(response_auth?.data?.token){
          localStorage.setItem('x_moon_token', response_auth?.data?.token);
          window.x_moon_token = response_auth?.data?.token;
          var user = response_auth?.data?.user;
        //  args.seGL_User(user);
          if(user.valid_thru){
           setRedirect("/my");
           
          }
        }
      }catch(e){
        var auth_token = window.x_moon_token || localStorage.getItem('x_moon_token');
        if(auth_token){
          setRedirect("/my");
        }
      }

      }*/

    // Update the document title using the browser API
    //console.log(args)
    try {
      //const response_settings = await axios.get(args.ApiUrl+"settings");
      setSettings(args.Settings);
     
      var auth_token = window.x_moon_token || localStorage.getItem('x_moon_token');

      const response = await axios.get(args.ApiUrl+"user",{headers:{"Authorization":"Bearer "+auth_token}});
      localStorage.setItem('user', JSON.stringify(response.data));
      setUser(response.data);
      if(typeof AndroidApp != "undefined"){
        return setRedirect("/my");
      }
      if(getPcidHashValue()){
        try{
        const personal_apply = await axios.post(args.ApiUrl+"apply-personal",{code:getPcidHashValue()},{headers:{"Authorization":"Bearer "+auth_token}});
        window.history.pushState("", document.title, window.location.pathname + window.location.search);
        setLoading(false);
      }catch(e){
        setLoading(false);
      }
      }else{
        setLoading(false);
      }
     


  
    } catch (error) {

        setSettings(args.Settings);
      
      if(typeof AndroidApp != "undefined"){
        return setRedirect("/app/auth");
      }else{
      setLoading(false);
      console.error('Ошибка при выполнении запроса:', error);
      }
    }

    }
    get_user();

  


  // setTimeout(()=>{setLoading(false)},1000)
  },[]);


  const handleTelegramResponse = async (tg_resp) => {
    setAuthModalLoading(true);
    setLoginError(false)
    setTimeout(async()=>{

    try {
 
      const response = await axios.post(args.ApiUrl+"auth-tg",tg_resp,{params:{ref:localStorage.getItem('ref'),pcid:getPcidHashValue()}});
      if(response?.data?.token){
        localStorage.setItem('x_moon_token', response?.data?.token);
        window.x_moon_token = response?.data?.token;
        var user = response?.data?.user;
        args.seGL_User(user);
        if(!user.valid_thru){
         setRedirect("/my/land");
         
        }else{
          setRedirect("/my");
        }
      }
    //  Setpricing(response.data?.plans);
    //  setLoading(false);
 
    } catch (error) {
      setAuthModalLoading(false);
      setLoginError(true)
      console.log('Ошибка при выполнении запроса:', error);
    }
  },1000)
  };
  const select_plan = async(plan)=>{
    if(User?.tg_id){
    setRedirect("/my/land?select_plan="+plan.id);
    }else{
      setAuthModalOpen(true);
    }
  }
  const handleStartButton = async(lk=false)=>{
    console.log(User);
    setMobileMenuOpen(false);
    if(User?.tg_id){
      if(!User.valid_thru){
        if(!lk){
        setRedirect("/my/land");
        }else{
          setRedirect("/my");
        }
       }else{
        setRedirect("/my");
       }
    }else{
      setAuthModalOpen(true);
    }
  }

  

  if(Redirect){
    return <Navigate to={Redirect} />
  }

  if(Loading){
    return(
     <LoadingSpinner/>
    ) 
  }
  return (
    <div>


<Transition show={AuthModalOpen}>
      <Dialog className="relative z-10" onClose={setAuthModalOpen}>
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden rounded-lg bg-slate-900 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-slate-900 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start justify-center">
               
                    <div className="mt-3 text-center sm:mt-0">
                      <DialogTitle as="h3" className="text-2xl font-semibold leading-6 text-gray-200">
                        Сначала нужно войти
                      </DialogTitle>
                      <div className="mt-4">
                        <p className="text-gray-300 text-md font-normal mt-3 text-center">
                          Используйте свой аккаунт Telegram для авторизации. Это безопасно: <a className="text-blue-400 hover:text-blue-200" href="https://core.telegram.org/widgets/login" target="_blank">мы не получим ваши данные и переписки</a>
                        </p>
                          {LoginError &&
                        <div className="flex bg-slate-800 p-3 gap-2 w-full mt-5 rounded-lg ring ring-red-500"><img src={ErrorSvg} className="h-14"/><div className="flex flex-col text-start gap-0"><span className="text-lg text-gray-200 font-black">Что-то пошло не так...</span><span className="text-lg text-gray-300 font-medium">Не удалось войти</span></div></div>
                          }
                        {!AuthModalLoading &&
                        <div className="mt-5 w-full flex justify-center">
                        <TelegramLoginButton dataOnauth={handleTelegramResponse} className="rounded-[20px]" botName={Settings.bot_username} data-request-access="write"/>
                        </div>
                        }
                        {AuthModalLoading &&
                        <div className="mt-5 w-full flex justify-center">
                       <span className="loading loading-spinner loading-lg"></span>
                        </div>
                        }

                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-900 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                {!AuthModalLoading &&
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-gray-300 px-3 py-2 text-md min-w-[120px] font-semibold text-black shadow-sm sm:ml-3 sm:w-auto"
                    onClick={() => setAuthModalOpen(false)}
                  >
                    Отмена
                  </button>
                  }
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>


<div className="bg-slate-900">
<header className="absolute inset-x-0 top-0 z-50 ">
    <nav className="flex items-center justify-between p-6 mx-auto max-w-5xl" aria-label="Global">
      <div className="flex lg:flex-1">
        <a href="#" className="-m-1.5 p-1.5">
          <span className="sr-only">Your Company</span>
          <img
            className="h-16 w-auto"
            src={Logo}
            alt=""
          />
        </a>
      </div>
      <div className="flex lg:hidden">
        <button
          type="button"
          className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-100"
          onClick={() => setMobileMenuOpen(true)}
        >
          <span className="sr-only">Open main menu</span>
          <Bars3Icon className="h-8 w-8" aria-hidden="true" />
        </button>
      </div>
      <div className="hidden lg:flex lg:gap-x-12">
        {Settings.landing_navigation.map((item) => (
          <a href={item.href.replace("%TG_START%",(localStorage.getItem('ref') ? "?start=r_"+localStorage.getItem('ref'):""))} className="text-lg font-semibold leading-6 text-gray-100 hover:text-violet-400">
            {item.name}
          </a>
        ))}
      </div>
      <div className="hidden lg:flex lg:flex-1 lg:justify-end">
        <button className="text-lg font-semibold leading-6 text-gray-100"  onClick={() => {handleStartButton(true);}}>
         Личный кабинет <span aria-hidden="true">&rarr;</span>
        </button>
      </div>
    </nav>
    <Dialog className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
      <div className="fixed inset-0 z-50" />
      <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-slate-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div className="flex items-center justify-between">
          <a href="#" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            <img
            className="h-16 w-auto"
            src={Logo}
            alt=""
          />
          </a>
          <button
            type="button"
            className="-m-2.5 rounded-md p-2.5 text-gray-100"
            onClick={() => setMobileMenuOpen(false)}
          >
            <span className="sr-only">Close menu</span>
            <XMarkIcon className="h-8 w-8" aria-hidden="true" />
          </button>
        </div>
        <div className="mt-6 flow-root">
          <div className="-my-6 divide-y divide-gray-500/10">
            <div className="space-y-2 py-6">
              {Settings.landing_navigation.map((item) => (
                <a
                  onClick={() => setMobileMenuOpen(false)}
                  href={item.href.replace("%TG_START%",(localStorage.getItem('ref') ? "?start=r_"+localStorage.getItem('ref'):""))}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-100 hover:bg-slate-700"
                >
                  {item.name}
                </a>
              ))}
            </div>
            <div className="py-6">
              <button
                onClick={() => {handleStartButton(true)}}
               
                className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-100 hover:bg-slate-700"
              >
                Личный кабинет
              </button>
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </header>
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div className="mx-auto max-w-5xl pt-12 sm:pt-48">
       
          <div className="flex flex-col-reverse sm:flex-row gap-8 sm:items-center">


        
            <div>
            <div className="hidden sm:mb-8">
            <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-400 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
              Announcing our next round of funding.{' '}
              <a href="#" className="font-semibold text-violet-600">
                <span className="absolute inset-0" aria-hidden="true" />
                Read more <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>


          <motion.h1
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
      className="text-4xl font-bold tracking-tight text-gray-100 sm:text-6xl"
    >
    Moon VPN
    </motion.h1>
    <motion.h1
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
      className="mt-6 text-lg leading-8 text-gray-300 font-medium"
    >
    Наш сервис обеспечивает безопасный доступ к контенту со всего мира без ограничений и цензуры. Мы уважаем вашу приватность и не сохраняем ваши личные данные
    </motion.h1>

    
    
    <motion.div
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
    >
            <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6">
              <button
              onClick={() =>handleStartButton()}
                href="javascript:void(0);"
                className="rounded-md bg-gradient-to-r from-[#e90ffc] to-[#13cbe1] px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm hover:bg-violet-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
              >
                Начать пользоваться
              </button>
              {!WebApp.initData&&
              <button onClick={() => OpenLink(Settings.telegram_bot+(localStorage.getItem('ref') ? "?start=r_"+localStorage.getItem('ref'):""))} target="_blank" className="text-lg font-semibold leading-6 text-gray-100 text-center">
                Наш Telegram бот <span aria-hidden="true">→</span>
              </button>
              }
            </div>

            </motion.div>        
            </div>



            <div className="relative flex h-full w-full max-w-[32rem] items-center justify-center overflow-hidden rounded-lg bg-background pt-44 pb-44 sm:py-56">
     
      <Globe />

    </div>

          </div>
        </div>


                
        <div
          className="absolute inset-x-0 top-[calc(100%-136rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-107rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>

        <div
          className="absolute inset-x-0 top-[calc(100%-80rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-50rem)]"
          aria-hidden="true"
        >
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>



        <div className="mx-auto max-w-5xl pt-12 sm:pt-24" id="feautures">

        <WordPullUp
      className="tracking-[-0.02em] text-2xl sm:text-4xl font-bold tracking-tight text-gray-100"
      words="Почему мы?"
    />
 <motion.div
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
    >
          <div className="flex flex-col-reverse sm:flex-row gap-8 sm:items-center mt-4 sm:mt-8">

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full h-full">
                    <div className="w-full h-full p-6 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col items-center transition ease-in-out duration-300 sm:hover:-translate-y-2.5">
                      <img src={IconChat} className="h-24 w-24"/>
                      <span className="text-xl text-gray-100 font-bold text-center">Telegram бот</span>
                      <span className="text-gray-300 text-lg font-normal mt-3 text-center">Оплата, настройки, получение профиля всегда под рукой - в Telegram боте</span>
                    </div>
                    <div className="w-full h-full p-6 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col items-center transition ease-in-out duration-300 sm:hover:-translate-y-2.5">
                      <img src={IconFast} className="h-24 w-24"/>
                      <span className="text-xl text-gray-100 font-bold text-center">Скорость до 1 Гбит/c</span>
                      <span className="text-gray-300 text-lg font-normal mt-3 text-center">Используем современное мощное оборудование в европейских локациях</span>
                    </div>
                    <div className="w-full h-full p-6 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col items-center transition ease-in-out duration-300 sm:hover:-translate-y-2.5">
                      <img src={IconSecure} className="h-24 w-24"/>
                      <span className="text-xl text-gray-100 font-bold text-center">Безопасность</span>
                      <span className="text-gray-300 text-lg font-normal mt-3 text-center">Не сохраняем историю подключений и блокируем рекламу на сайтах</span>
                    </div>
                    <div className="w-full h-full p-6 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col items-center transition ease-in-out duration-300 sm:hover:translate-y-2.5">
                      <img src={IconFirewall} className="h-24 w-24"/>
                      <span className="text-xl text-gray-100 font-bold text-center">VLESS протокол</span>
                      <span className="text-gray-300 text-lg font-normal mt-3 text-center">Самый современный протокол, который не могут заблокировать даже в Китае</span>
                    </div>
                    <div className="w-full h-full p-6 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col items-center transition ease-in-out duration-300 sm:hover:translate-y-2.5">
                      <img src={IconCard} className="h-24 w-24"/>
                      <span className="text-xl text-gray-100 font-bold text-center">Доступные цены</span>
                      <span className="text-gray-300 text-lg font-normal mt-3 text-center">Безлимитный доступ по подписке на удобный срок по лучшим ценам</span>
                    </div>
                    <div className="w-full h-full p-6 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col items-center transition ease-in-out duration-300 sm:hover:translate-y-2.5">
                      <img src={IconSupport} className="h-24 w-24"/>
                      <span className="text-xl text-gray-100 font-bold text-center">Поддержка 24/7</span>
                      <span className="text-gray-300 text-lg font-normal mt-3 text-center">Наши специалисты всегда готовы помочь вам, если что-то не заработает</span>
                    </div>

                  </div>
      
          </div>
          </motion.div>

        </div>

        
        <div className="mx-auto max-w-5xl pt-12 sm:pt-24">

        <WordPullUp
      className="tracking-[-0.02em] text-2xl sm:text-4xl font-bold tracking-tight text-gray-100"
      words="Умная маршрутизация"
    />
 <motion.div
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
    > 
      <span className="mt-3 text-lg text-gray-300 font-normal block">Через зарубежные серверы будем грузить только то, что не получается загрузить из России. Такой подход повышает скорость и стабильность соединения</span>
          
          

      <div
      className="relative flex w-full items-center justify-center overflow-hidden rounded-lg bg-background py-10"
      ref={containerRef}
    >
      <div className="flex h-full w-full flex-col items-stretch justify-between gap-10">
        <div className="flex flex-row justify-between">

        <div
      ref={div1Ref}
      className="z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 bg-white p-2.5 shadow-[0_0_20px_-12px_rgba(0,0,0,0.8)]"
    >
<img src={IconUser} className="w-full"/>
    </div>


<div className="flex flex-col gap-8">
    <div
      ref={div2Ref}
      className="z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 bg-white p-2 shadow-[0_0_20px_-12px_rgba(0,0,0,0.8)]"
    >
<img src={IconFlagRu} className="w-full"/>
    </div>

    <div
      ref={div3Ref}
      className="z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 bg-white p-2 shadow-[0_0_20px_-12px_rgba(0,0,0,0.8)]"
    >
<img src={IconFlagDE} className="w-full"/>
    </div>
</div>


<div className="flex flex-col gap-8">
    <div
      ref={div4Ref}
      className="z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 bg-white p-2 shadow-[0_0_20px_-12px_rgba(0,0,0,0.8)]"
    >
<img src={IconSocVK} className="w-full"/>
    </div>
    <div
      ref={div5Ref}
      className="z-10 flex h-14 w-14 items-center justify-center rounded-full border-2 bg-white p-2 shadow-[0_0_20px_-12px_rgba(0,0,0,0.8)]"
    >
<img src={IconSocIG} className="w-full"/>
    </div>
</div>
        </div>
      </div>
 
      <AnimatedBeam
        duration={5}
        containerRef={containerRef}
        fromRef={div1Ref}
        toRef={div2Ref}
      />
         <AnimatedBeam
        duration={5}
        containerRef={containerRef}
        fromRef={div2Ref}
        toRef={div3Ref}
      />
           <AnimatedBeam
        duration={5}
        containerRef={containerRef}
        fromRef={div2Ref}
        toRef={div4Ref}
      />
             <AnimatedBeam
        duration={5}
        containerRef={containerRef}
        fromRef={div3Ref}
        toRef={div5Ref}
      />
    </div>
          <div className="flex w-full justify-center">
    <h1 class="text-4xl font-black bg-clip-text text-transparent bg-gradient-to-r from-[#e90ffc] to-[#13cbe1] text-center">В 10 раз быстрее, чем простой VPN</h1>
    </div>

          </motion.div>

        </div>
        <div className="mx-auto max-w-5xl pt-12 sm:pt-24">

        <WordPullUp
      className="tracking-[-0.02em] text-2xl sm:text-4xl font-bold tracking-tight text-gray-100"
      words="Тарифы"
    />
 <motion.div
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
      className="mt-6"
      id="pricing"
    > 
    <Tarifs  ApiUrl={args.ApiUrl} isLk={false} onSelect={(plan)=>{select_plan(plan);}}/>
    <div className="flex flex-col items-center mt-0 pb-6">
      <img src={IconInfinity} className="h-20"/>
      <span className="text-xl sm:text-3xl text-gray-100 font-black mt-0 block text-center">Все тарифы без лимитов по скорости</span>
    </div>

    </motion.div>
        </div>

        <div className="mx-auto max-w-5xl pt-12 sm:pt-24">

        <WordPullUp
      className="tracking-[-0.02em] text-2xl sm:text-4xl font-bold tracking-tight text-gray-100"
      words="Бесплатный доступ навсегда"
    />
    
 <motion.div
      initial="hidden"
      animate="visible"
      transition={1}
      variants={BlurDefaultVariants}
    > 
<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pb-16">
<div className=" mt-4 sm:mt-8 w-full h-full px-6 pt-1 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col transition ease-in-out duration-300">
  <img src={IconRef} className="h-24 w-24"/>
  <span className="text-xl text-gray-100 font-bold mt-3 block">+{Settings.ref_bonus} ₽ за каждого друга</span>
  <span className="text-gray-300 text-lg font-normal mt-1">Приглашайте новых пользователей по реферальной ссылке и получайте подписку бесплатно!<br/>Без ограничений и доп. условий</span>
  <button
              onClick={() => {handleStartButton();}}
                className="text-gray-900  hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gray-200 px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
              >
                Пригласить
              </button>


</div>
<div className=" mt-4 sm:mt-8 w-full h-full px-6 pt-1 text-white bg-slate-800 rounded-lg shadow-lg flex flex-col transition ease-in-out duration-300">
  <img src={IconNews} className="h-24 w-24"/>
  <span className="text-xl text-gray-100 font-bold mt-3 block">Следите за новостями</span>
  <span className="text-gray-300 text-lg font-normal mt-1">Вступайте в наш Telegram канал, там мы публикуем новости проекта и промокоды на бесплатную подписку!</span>
  <button
                onClick={() => OpenLink(Settings.telegram_channel)}
                target="_blank"
                className="text-gray-900 hover:scale-105 duration-300 mt-5 block w-full rounded-md bg-gray-200 px-3.5 py-2.5 text-lg font-semibold text-gray-100 shadow-sm text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
              >
                Подписаться
              </button>


</div>
</div>
                    
    </motion.div>
    </div>


    <div className="mx-auto max-w-5xl pt-12 sm:pt-24 pb-16">
<motion.div
initial="hidden"
animate="visible"
transition={1}
variants={BlurDefaultVariants}
> 

<div className="flex justify-center items-center flex-col w-full gap-8">
<span
      className="tracking-[-0.02em] text-2xl sm:text-4xl font-bold tracking-tight text-gray-100 text-center"
      
    >Подключайся прямо сейчас в 2 клика</span>

<button                
                onClick={() => {handleStartButton(true)}}
                className="min-w-[300px] hover:scale-105 duration-300 rounded-md bg-gradient-to-r from-[#e90ffc] to-[#13cbe1] px-3.5 py-2.5 text-xl font-semibold text-gray-100 shadow-sm hover:bg-violet-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600 text-center"
              >
                В личный кабинет
              </button>
</div>     
</motion.div>         
</div>

      </div>

        <div className="w-full bg-slate-900">
      <div className="mx-auto max-w-5xl pt-12 sm:pt-24 pb-6">
      {Settings.show_inn && 
      
      <motion.div
initial="hidden"
animate="visible"
transition={1}
variants={BlurDefaultVariants}
> 
<div className="px-6 sm:px-0">
<span className="text-gray-400 font-medium text-lg">
Ахмедова Диана Яхъяевна (ИНН: 051127755599) <br/>
<a href="phone:+79884438989" className="text-2xl text-indigo-400">+7 (988) 443-89-89</a>
</span>
</div>
</motion.div>     
      }
      {!Settings.show_inn && 
      
      <motion.div
initial="hidden"
animate="visible"
transition={1}
variants={BlurDefaultVariants}
> 
<div className="px-6 sm:px-0">
<span className="text-gray-400 font-medium text-lg">
© MoonVpn Team <br/>
</span>
</div>
</motion.div>     
    }
    
</div>
</div>
    </div>






    </div>
  );
}

export default App;
